import type { ReactNode } from 'react';
import { LoadingIndicator } from './loading';
import { useWidgetCommunication } from './communication';
import { useTextsLoading } from './texts';

type Props = { children: ReactNode };

const AppLoader = ({ children }: Props) => {
  const communicationContext = useWidgetCommunication();
  const textsLoading = useTextsLoading();

  if (!communicationContext || textsLoading)
    return <LoadingIndicator />;

  return children;
};

export default AppLoader;
